const zh = {
  menuMessage:{ 
    home:'首页',
    product: '产品中心',
    new: '资讯动态',
    about: '关于我们',
    contact: '联系我们'
  },
  contactUs: {
    contact: '联系我们',
    phone: '电话',
    email: '邮箱',
    address: '地址'
  }
}
export default zh;
